<template>
  <div class="main point_body">
    <h6 class="point_all">
      <el-checkbox
        v-model="allInfo.check"
        size="medium"
        class="check_all"
        :indeterminate="allInfo.indeterminate"
        @change="checkAllChange">全选
      </el-checkbox>
      <div class="fr">
          <span>总屏幕:</span>
          <span class="hl">{{ allCheckDeviceNum }}</span>
          <span class="dark">/{{ allDeviceNum }}</span>
        </div>
    </h6>
    <div v-for="building in buildingList" :key="building.guid" class="point_rows">
      <div class="point_rows_title" @click="toggleShowContent(building)">
        <el-checkbox
          v-model="building.check"
          size="medium"
          class="building_check"
          @change="(value)=>{buildingCheckChange(building,value)}"
          :indeterminate="building.selectDeviceCount>0&&building.selectDeviceCount<building.allDeviceCount"
        >
          <span>{{building.building}}</span>
          <template v-if="!isExport">
            <span v-if="building.canSelect">(推荐度{{(building.recommend*100).toFixed(0)}}%)</span>
          </template>
          <span v-if="!building.canSelect">(缺货)</span>
        </el-checkbox>
        <div class="fr">
          <span>已选屏幕:</span>
          <span class="hl">{{building.selectDeviceCount||0}}</span>
          <span class="dark">/{{ building.allDeviceCount }}</span>
          <i v-if="building.showContent" class="icon_toggle el-icon-arrow-up"></i>
          <i v-else class="icon_toggle el-icon-arrow-down"></i>
        </div>
      </div>
      <div v-if="building.showContent" class="point_detail">
        <div v-for="(unit,index) in building.unitDeviceList" :key="index" class="point_item">
          <span class="p_i_title"
                :style="(building.canSelect&&unit.canSelect)?{}:{color: '#c0c4cc'}">{{unit.unit}}</span>
          <div class="point_list">
              <span v-for="device in unit.deviceList" :key="device.deviceGuid">
                  <el-checkbox
                    v-model="device.check"
                    @change="()=>{deviceCheckChange(building)}" class="building_check">
                    <span>{{device.deviceName}}
                      <template v-if="!isExport">
                        <i v-if="device.canSelect">({{(device.recommend*100).toFixed(0)}}%)</i>
                      </template>
                      <i v-if="!device.canSelect">(缺货)</i>
                    </span>
<!--                    <span></span>-->
<!--                    <span>流量：{{device.canSelect}}</span>-->
                  </el-checkbox>
              </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeviceList",
  props: {
    buildingList: {
      type: Array,
      default () {
        return []
      }
    },
    isExport: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    allDevice () {
      return this.buildingList.reduce((data, cur) => {
        return data.concat(
          (cur.unitDeviceList || []).reduce((data1, cur1) => {
            return data1.concat(cur1.deviceList || [])
          }, [])
        )
      }, [])
    },
    allDeviceNum () {
      return this.allDevice.length
    },
    allCheckDeviceNum () {
      return this.allDevice.filter(el => el.check).length
    },
    allInfo () {
      let check = false
      let indeterminate = false
      let checkall = true
      this.buildingList.forEach((building) => {
        if (building.check) {
          check = true
        }
        if (building.selectDeviceCount > 0 && building.selectDeviceCount < building.allDeviceCount) {
          indeterminate = true
          checkall = false
        }
        if (!building.check) {
          checkall = false
        }
      })
      if (check && !checkall) indeterminate = true
      return { check, indeterminate }
    }
  },
  watch: {
    buildingList: {
      deep: true,
      handler () {
        this.countCommunity()
      }
    }
  },
  methods: {
    checkAllChange (value) {
      this.buildingList.forEach(building => {
        this.buildingCheckChange(building, value)
      })
    },
    buildingCheckChange (data, value) {
      let selectDevice = 0
      let slotAmount = 0
      data.unitDeviceList.forEach(unit => {
        unit.deviceList.forEach(device => {
          device.check = value
          if (value) {
            selectDevice++
            slotAmount += device.amount
          }
        })
      })
      data.check = value
      data.selectSlotAmount = slotAmount
      data.selectDeviceCount = selectDevice
    },
    deviceCheckChange (data) {
      let selectDevice = 0
      let slotAmount = 0
      data.unitDeviceList.forEach(unit => {
        unit.deviceList.forEach(device => {
          if (device.check) {
            selectDevice++
            slotAmount += device.amount
          }
        })
      })
      data.selectDeviceCount = selectDevice
      data.selectSlotAmount = slotAmount
      data.check = selectDevice > 0
    },
    countCommunity () {
      let selectDevice = 0
      let selectSlotAmount = 0
      this.buildingList.forEach(item => {
        if (item.check) {
          selectDevice += item.selectDeviceCount
          selectSlotAmount += item.selectSlotAmount
        }
      })
      this.$emit('change', {
        selectDeviceCount: selectDevice,
        selectSlotAmount: selectSlotAmount,
        buildingList: this.buildingList
      })
      this.$forceUpdate()
    },
    toggleShowContent (item) {
      item.showContent = !item.showContent
      this.$forceUpdate()
    }
  }
}
</script>

<style lang=scss scoped>
.point_body {
  max-height: 440px;
  background-color: #fff;
  border: 1px solid #EAEBF0;
  overflow-y: auto;
  .hl {
    color: #FF3973;
  }
  .point_all {
    padding: 10px;
    font-size: 14px;
    line-height: 20px;
    border-bottom: 1px solid #EAEBF0;
  }
  .point_rows {
    margin: 10px;
    background-color: #F5F5F5;
    .point_rows_title {
      padding: 10px;
    }
  }
  .point_detail {
    box-shadow: 0 1px 0 0 #e9e9e9;
    .point_item {
      position: relative;
      overflow: hidden;
      .p_i_title {
        display: inline-block;
        color: #282729;
        font-size: 14px;
        line-height: 20px;
        padding: 10px 10px;
        width: 140px;
        box-shadow: 0 1px 0 0 #e9e9e9, 0 1px 0 0 #e9e9e9 inset;
      }
    }
  }
  .point_list {
    float: right;
    display: flex;
    width: calc(100% - 140px);
    justify-content: flex-end;
    flex-wrap: wrap;
    box-shadow: 0 1px 0 0 #e9e9e9 inset;
    .el-checkbox {
      width: 297px;
      height: 40px;
      margin-left: 0;
      padding: 10px 10px;
      box-shadow: 0 1px 0 0 #e9e9e9, -1px 0 0 0 #e9e9e9;
      box-sizing: border-box;
      span:first-child{
        /*width: 120px;*/
        display: inline-block;
      }
      span:nth-child(even){
        border-left: 1px solid #E9E9E9;
      }
      span{
        padding-right: 10px;
      }
      ::v-deep .el-checkbox__label {
        color: #282729;
        font-size: 14px;
        line-height: 20px;
      }
      &.is-disabled ::v-deep .el-checkbox__label {
        color: #a3a3a3;
      }
    }
  }
  .icon_toggle {
    font-size: 12px;
    color: #999;
    margin-left: 10px;
  }
  .dark {
    color: #282729;
  }
  .ml10 {
    margin-left: 10px;
  }
}
</style>
